import { render, staticRenderFns } from "./evidence.vue?vue&type=template&id=4b5b5948&scoped=true&"
import script from "./evidence.vue?vue&type=script&lang=js&"
export * from "./evidence.vue?vue&type=script&lang=js&"
import style0 from "./evidence.vue?vue&type=style&index=0&id=4b5b5948&prod&lang=scss&scoped=true&"
import style1 from "./evidence.vue?vue&type=style&index=1&id=4b5b5948&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b5948",
  null
  
)

export default component.exports